<template>
  <div class="categories" style="background: #101431">
    <v-card-text style="    text-align: -webkit-center;">
      <v-row style="background: #50545f;margin:30px;max-width: 920px;">
        <v-col cols="6" class="text-center"  style="padding: 50px">
          <div style="color: white" class="mt-5 text-center">{{ $t('showCredit') }}</div>
          <div v-if="card_info.MainCard!=null"  style="height:200px;border-radius:15px;background: url('/img/golden_card_back.png')">
            <v-row style="padding-top: 25px;">
              <v-col  style="font-weight: bold" >{{ $t('zoodkomakGoldenCard') }}</v-col>
              <v-col ><img style="width: 60px" src="/img/qr_code.svg"/></v-col>
            </v-row>
            <v-row style="margin-top: 30px;">
              <v-col  style="font-weight: bold"  >{{JSON.parse(card_info.MainCard).OwnerName}}</v-col>
              <v-col  style="font-weight: bold" >{{ $t('expired', {format: moment(JSON.parse(card_info.MainCard).EndDate).locale('fa').format("jYY/jMM")}) }}</v-col>
            </v-row>
            <div style="margin-top: 10px;direction: ltr;font-weight: bold;font-size: 22px;">{{JSON.parse(card_info.MainCard).CardCode.replace(/\B(?=(\d{4})+(?!\d))/g,
              " ")}}</div>
          </div>
          <div>
            <v-row style="color: white">
              <v-col>{{ $t('credit') }}</v-col>
              <v-col>{{JSON.parse(card_info.MainCard).Credit.toString().replace(/\B(?=(\d{3})+(?!\d))/g,
                ",")}}</v-col>
            </v-row>

          </div>

          <hr>
          <label style="font-weight: bold;text-align: start;color: white">{{ $t('servicesList') }}</label>
          <div @click="get_services_info" v-if="card_info.Services!=null" style="text-align: start;color: white" v-for="service in JSON.parse(card_info.Services)">
            <label style="text-align: start;color: white">{{service.CardTypeTitle}}</label>
          </div>
        </v-col>
        <v-col cols="6" class="text-center" style="padding: 20px">

          <div style="color: white" class="mt-5 text-center">{{ $t('whatIsGoldenCard') }}</div>
          <div style="color: white" class="mt-5 text-center">{{ $t('goldenCardDescription') }}</div>
          <v-text-field
            outlined
            dense
            dark
            v-model="request_card_name"
            :label="$t('nameLastName')"/>
          <v-text-field
            outlined
            dense
            dark
            v-model="request_card_mobile"
            :label="$t('phoneNo')"/>
          <v-btn outlined
                 dark
          >{{ $t('send') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
    <v-dialog class=""
              max-width="800"
              v-model="dialog_info"
              persistent >
      <v-card class="dialog1-card" >
        <div class="text-center">
          <span class="name">
            {{ $t('bamland') }}
          </span>
          <span class="back-btn"  @click="dialog_info = false">
               <img src="/img/close_icon.svg" style="width: 30px"/>
          </span>
          <div>
<img src="/img/bam_land.jpg"/>
          </div>
          <div>
            {{ $t('aboutBamland') }}
          </div>
        </div>
        <v-card-text>
          <v-container>
            <div class="technician-name" style="text-align: right;">
              {{ $t('shomareTamas') }}

            </div>

            <div class="technician-name" style="text-align: right;">
              {{ $t('bamlandadress') }}
            </div>

          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
  import InfiniteLoading from 'vue-infinite-loading';
  import moment from 'moment-jalaali'
  export default {
    components: {
      InfiniteLoading,
    },
    data() {
      return {
         moment :null,
        dialog_info:false,
      card_number: '',
        card_info: {},
        request_card_name: '',
        request_card_mobile: '',
        blog_data: {},
        isMobile: false,
        selected_item_id: '',
        last_class_name: '',
        errors: [],
        page: 1,
      }
    },
    watch: {},
    mounted() {
      this.moment = (moment);

      this.card_number =   this.$route.params.card_number
      this.get_card_info()
      // this.get_blogs()
    },
    methods: {
      resize_mobile() {
        if (window.innerWidth < 600) {
          this.isMobile = true
        } else {
          this.isMobile = false
        }
      },
      get_services_info(){
        this.dialog_info = true;
      },
      get_card_info() {
        var self = this;
        var send_data = {
          CardCode: this.card_number
        }
        this.axios.post('/GetCardInfoByCode', send_data, {})
          .then(response => {

this.card_info = response.data;
          }).catch(e => {
          this.errors.push(e)
        })
      },

      get_item_color(item_id) {
        if (item_id == this.selected_item_id) {
          return '#cee2f7'
        } else {
          return 'white'
        }
      },
      add_request(id, cat_id, title) {
        // if (this.dataset.post_id != null) {
        // localStorage.setItem("RequestPostId", id);
        // localStorage.setItem("RequestPostName", title);
        // localStorage.setItem("RequestPostBrand",cat_id);
        // window.open('/#AddRequest', "_self");
        // var passing_data = JSON.parse(localStorage.getItem('request_data'))
        var passing_data = JSON.parse(localStorage.getItem('request_data'))

        // passing_data.sub_group_id = item_id
        // passing_data.request_name = passing_data.request_name + title + ' '
        passing_data.post_id = id
        passing_data.post_name = title
        passing_data.post_brand_id = cat_id

        localStorage.setItem('request_data', JSON.stringify(passing_data))
        this.$router.push({name: 'request_detail', params: {}})

        // this.$router.push({ path: 'brands', params: {} })

        // }
      },
      post_view(id) {
        window.open('https://bilbordz.com/api/view_post/' + id)

      },
      get_categories() {
        // console.log("datas is "+localStorage.getItem('request_data'))
        var self = this
        var passing_data = JSON.parse(localStorage.getItem('request_data'))
        var cat_id = passing_data.sub_group_id

        const send_data = {
          groupId: cat_id,
        }
        var formData = new FormData()
        formData.append('groupId', cat_id)
        // this.axios.post('/Register' , send_data,{
        this.axios.post('https://cp.zoodkomak.com/api/get_group_posts', formData, {})
          .then(response => {
            if (response.data.error == 0) {
              // console.log("response", response);
              // self.fullName = response.data.msg;
              self.items = response.data.posts
              // self.level = 2;
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      }
    }
  }
</script>
<style>
  .blog-post {
    padding: 5px
  }

  .blog-post .article {
    padding: 3px;
    border: 1px solid #cfcdcd;
  }


</style>
